import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { errMsg, money, card, input, StatusPill } from './ui';

// Cross-store order feed (read-only summary) — manage/refund from each store's Orders tab.
export const AllStoreOrders = ({ stores }) => {
  const [orders, setOrders] = useState(null);
  const [status, setStatus] = useState('');
  useEffect(() => { axios.get('/stores/orders/all', { params: status ? { status } : {} }).then((r) => setOrders(r.data.orders)).catch((e) => toast.error(errMsg(e, 'Could not load store orders'))); }, [status]);
  const byId = Object.fromEntries(stores.map((s) => [s.id, s]));
  return (
    <section style={{ ...card, padding: 0 }} data-testid="all-store-orders">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px', borderBottom: '1px solid #27272A' }}>
        <h2 style={{ margin: 0, fontWeight: 800, fontSize: 16, flex: 1 }}>Store orders — all stores</h2>
        <select value={status} onChange={(e) => setStatus(e.target.value)} style={{ ...input, width: 'auto' }} data-testid="all-orders-filter"><option value="">All statuses</option>{['paid', 'in_production', 'ready_for_pickup', 'shipped', 'completed', 'refunded', 'canceled'].map((s) => <option key={s} value={s}>{s.replace(/_/g, ' ')}</option>)}</select>
      </div>
      {orders && orders.length === 0 && <p style={{ padding: 16, color: '#A1A1AA', fontSize: 13 }} data-testid="all-orders-empty">No store orders yet.</p>}
      {(orders || []).map((o) => (
        <Link key={o.id} to={`/stores/${o.store_id}/orders`} data-testid={`all-order-${o.order_number}`} style={{ display: 'grid', gridTemplateColumns: '110px 1.3fr 1.2fr 1fr 80px 100px 130px', gap: 10, alignItems: 'center', padding: '11px 16px', borderTop: '1px solid #1F1F23', fontSize: 13, color: '#fff', textDecoration: 'none' }}>
          <b>{o.order_number}</b>
          <span style={{ color: '#A5B4FC' }}>{byId[o.store_id]?.name || o.store_name}</span>
          <span>{o.customer?.name}<div style={{ color: '#71717A', fontSize: 11 }}>{o.customer?.email}</div></span>
          <span style={{ color: '#A1A1AA' }}>{new Date(o.created_at).toLocaleString()}</span>
          <span>{o.quantity || 0} item{o.quantity === 1 ? '' : 's'}</span>
          <b>{money(o.total)}</b>
          <StatusPill status={o.status} />
        </Link>
      ))}
    </section>
  );
};
